import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import { Urls } from 'kts-platform-frame/entry/constant';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Button, Row, Col, Icon, Spin, Modal } from 'antd';

import BillModelData from '../ModelData';

// 订单
import OrderBillTable from './UI.OrderBillTable';
import OrderBaseInfo from './UI.OrderBaseInfo';
import OrderAddition from './UI.OrderAddition';
// 计划单
import ForecastBillTable from './UI.ForecastBillTable';
import ForecastBaseInfo from './UI.ForecastBaseInfo';
import ForecastAddition from './UI.ForecastAddition';
// 发货单
import DespatchAdviceBillTable from './UI.DespatchAdviceBillTable';
import DespatchAdviceBaseInfo from './UI.DespatchAdviceBaseInfo';
import DespatchAdviceAddition from './UI.DespatchAdviceAddition';
// 收货单
import ReceiptAdviceBillTable from './UI.ReceiptAdviceBillTable';
import ReceiptAdviceBaseInfo from './UI.ReceiptAdviceBaseInfo';
import ReceiptAdviceAddition from './UI.ReceiptAdviceAddition';
// 入库单
import StockInNoticeBillTable from './UI.StockInNoticeBillTable';
import StockInNoticeBaseInfo from './UI.StockInNoticeBaseInfo';
import StockInNoticeAddition from './UI.StockInNoticeAddition';
// 合同
import ContractBillTable from './UI.ContractBillTable';
import ContractBaseInfo from './UI.ContractBaseInfo';
import ContractAddition from './UI.ContractAddition';
// 拒绝弹框
import RefuseM from './UI.RefuseM';
// 转换单据选择 弹框
import SelectBillTypeM from './UI.SelectBillTypeM';


const css = require('./index.scss');
const REJECTED = require('./img/REJECTED.png');
const ACCEPTED = require('./img/ACCEPTED.png');
const DRAFT = require('./img/DRAFT.png');
const RECEIVED = require('./img/RECEIVED.png');
const SENT = require('./img/SENT.png');
const ISSUED = require('./img/ISSUED.png');
// 作废
const CANCEL_REQUESTING = require('./img/CANCEL_REQUESTING.png');
const CANCEL_REJECTED = require('./img/CANCEL_REJECTED.png');
const CANCELED = require('./img/CANCELED.png');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { loadingUrls } = this.props;
        let documentInfo = undefined;
        switch (this.modulesState.billType) {
            case 'Order':
                documentInfo = this.modulesState.documentInfo;
                break;
            case 'Contract':
                documentInfo = this.modulesState.ContractForm;
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                documentInfo = this.modulesState.forecastForm;
                break;
            case 'DespatchAdvice':
                documentInfo = this.modulesState.despatchAdviceForm;
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                documentInfo = this.modulesState.receiptAdviceForm;
                break;
            case 'StockInNotice':
                documentInfo = this.modulesState.stockInNoticeForm;
                break;
            default:
                break;
        }
        const typeName = BillModelData.documentType[this.modulesState.billType];
        return (
            <div>
                <Spin spinning={loadingUrls.size > 0}>
                    {
                        this.modulesState.documentInfo &&
                        <div className={css.billDetail}>
                            <div className={css.header}>
                                <div className={css.title}>
                                    <div className={css.crumbs}><span style={{ cursor: 'pointer' }} onClick={() => ModulesAction.goBack()}>单据</span> {">"} {typeName}</div>
                                    <div className={css.titleType}>{typeName}</div>
                                </div>
                                <div className={css.goBack}>
                                    {
                                        this.modulesState.documentStatus === 'ISSUED' &&
                                        <img src={ISSUED} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'ACCEPTED' &&
                                        <img src={ACCEPTED} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'REJECTED' &&
                                        <img src={REJECTED} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'DRAFT' &&
                                        <img src={DRAFT} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'RECEIVED' &&
                                        <img src={RECEIVED} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'SENT' &&
                                        <img src={SENT} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'CANCEL_REQUESTING' &&
                                        <img src={CANCEL_REQUESTING} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'CANCEL_REJECTED' &&
                                        <img src={CANCEL_REJECTED} className={css.billSatus} />
                                    }
                                    {
                                        this.modulesState.documentStatus === 'CANCELED' &&
                                        <img src={CANCELED} className={css.billSatus} />
                                    }
                                    <Button key="back" className="kts-but-default" onClick={() => ModulesAction.goBack()}>返回</Button>
                                </div>
                            </div>
                            <div className={css.content}>
                                {this.getBaseInfoUI()}
                                {
                                    documentInfo &&
                                    <div className={css.additional}>
                                        <Row style={{ lineHeight: '36px' }}>
                                            <Col span={12}>
                                                {this.getAdditionUI()}
                                                <Row>
                                                    <Col span={5}>
                                                        <span className={css.titleName}>备注</span>
                                                    </Col>
                                                    <Col span={19}>
                                                        <div className={css.info}>{documentInfo.Note}</div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={5}>
                                                        <span className={css.titleName}>附件</span>
                                                    </Col>
                                                    <Col span={19}>
                                                        <div className={css.info}>
                                                            {this.getAdditional(documentInfo.Attachments)}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={10} offset={2}>
                                                {ModulesAction.getExtraTemplate(documentInfo)}
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            </div>
                            {this.modulesState.refuseM && <RefuseM />}
                            {
                                !this.modulesState.isArchived &&
                                <div className={css.footer}>
                                    <Button
                                        onClick={() => this.documentArchive()}
                                        className="kts-but-default"
                                        style={{ marginRight: '12px' }}
                                    >
                                        存档
                                    </Button>
                                    {
                                        this.modulesState.documentStatus === 'ISSUED' &&
                                        <Button
                                            onClick={() => ModulesAction.documentSend()}
                                            className="kts-but-general"
                                            style={{ marginRight: '12px' }}
                                        >
                                            发送
                                        </Button>
                                    }
                                    {
                                        this.modulesState.allowedDocType.length > 0 &&
                                        <Button
                                            onClick={() => ModulesAction.changeBillTypeM()}
                                            className="kts-but-default"
                                            style={{ marginRight: '12px' }}
                                        >
                                            转换
                                        </Button>
                                    }
                                    {this.allowedTargetStatus()}
                                </div>
                            }
                            {
                                this.modulesState.isArchived &&
                                <div className={css.footer}>
                                    <Button
                                        onClick={() => ModulesAction.documentArchive()}
                                        className="kts-but-default"
                                        style={{ marginRight: '12px' }}
                                    >
                                        取消存档
                                    </Button>
                                </div>
                            }
                        </div>
                    }
                </Spin>
                <SelectBillTypeM />
            </div>
        );
    }
    /**
     *  拒绝 和 接受 按钮
     */
    private allowedTargetStatus = () => {
        let allowedTargetStatus = this.modulesState.allowedTargetStatus;
        let temp = [];
        allowedTargetStatus.forEach(element => {
            switch (element) {
                case 'REJECTED':
                    temp.push(
                        <Button
                            key={element}
                            onClick={() => ModulesAction.refuseM('REJECTED')}
                            className="kts-but-default"
                            style={{ marginRight: '12px' }}
                        >
                            拒绝
                        </Button>
                    );
                    break;
                case 'ACCEPTED':
                    temp.push(
                        <Button
                            key={element}
                            className="kts-but-general"
                            onClick={() => ModulesAction.updataDocumentStatus('ACCEPTED')}
                            style={{ marginRight: '12px' }}
                        >
                            接受
                        </Button>
                    );
                    break;
                case 'CANCEL_REJECTED':
                    temp.push(
                        <Button
                            key={element}
                            onClick={() => ModulesAction.refuseM('CANCEL_REJECTED')}
                            className="kts-but-default"
                            style={{ marginRight: '12px' }}
                        >
                            拒绝作废
                        </Button>
                    );
                    break;
                case 'CANCELED':
                    temp.push(
                        <Button
                            key={element}
                            className="kts-but-general"
                            onClick={() => ModulesAction.updataDocumentStatus('CANCELED')}
                            style={{ marginRight: '12px' }}
                        >
                            {this.modulesState.isSenderParty ? '作废' : '接受作废'}
                        </Button>
                    );
                    break;
                default:
                    break;
            }
        });
        return temp;
    }
    /**
     * 修改归档
     */
    private documentArchive = () => {
        Modal.confirm({
            title: '提示',
            content: '存档后，您可以再取消存档。',
            onOk: () => {
                ModulesAction.documentArchive();
            },
        });
    }
    /**
     * 获取不同类型的 基础数据UI
     */
    private getBaseInfoUI = () => {
        let temp;
        switch (this.modulesState.billType) {
            case 'Order':
                temp = <div><OrderBaseInfo /><OrderBillTable /></div>;
                break;
            case 'Contract':
                temp = <div><ContractBaseInfo /><ContractBillTable /></div>;
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                temp = <div><ForecastBaseInfo /><ForecastBillTable /></div>;
                break;
            case 'DespatchAdvice':
                temp = <div><DespatchAdviceBaseInfo /><DespatchAdviceBillTable /></div>;
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                temp = <div><ReceiptAdviceBaseInfo /><ReceiptAdviceBillTable /></div>;
                break;
            case 'StockInNotice':
                temp = <div><StockInNoticeBaseInfo /><StockInNoticeBillTable /></div>;
                break;
            default:
                break;
        }
        return temp;
    }
    /**
     * 获取不同类型的 附加信息UI
     */
    private getAdditionUI = () => {
        let temp;
        switch (this.modulesState.billType) {
            case 'Order':
                temp = <OrderAddition />;
                break;
            case 'Contract':
                temp = '';
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                temp = '';
                break;
            case 'DespatchAdvice':
                temp = <DespatchAdviceAddition />;
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                temp = <ReceiptAdviceAddition />;
                break;
            case 'StockInNotice':
                temp = '';
                break;
            default:
                break;
        }
        return temp;
    }

    /**
     * 附件列表
     */
    private getAdditional = (data: any[]) => {
        let arrList = [];
        data.forEach(element => {
            arrList.push(<div onClick={() => ModulesAction.documentAttachmentGet(element.UUID)} key={element.UUID} className={css.uploadDoc}><Icon type="paper-clip" />{element.FileName}</div>);
        });
        return arrList;
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/UI.Components.tsx